module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av51-02c607304df8905a1cf97d0c2f0c1e87.jpg";